<div class="currentAgentStatesTableView h-100 w-100 d-flex flex-column">
    <!-- Search regular -->
    <div class="search-box live-search w-75 mx-auto my-2" [hidden]="!showFilter">
        <input #filterInput type="search" class="form-control" autocomplete="off" [(ngModel)]="filterValue" [ngModelChangeDebounceTime]="400" (ngModelChangeDebounced)="applyFilter()"
            placeholder="Search" runat="server" langSection="Common" langKey="Search" cvLocalizedPlaceholder/>
        <span class="clear-input" role="button" tabindex="0" [hidden]="filterValue.length <= 0" (click)="clearFilter()"></span>
    </div>
    <!-- Table -->
    <div [hidden]="noData" class="grid-container flex-fill overflow-auto">
        <ag-grid-angular 
            #agentListWidgetGrid
            *ngIf="gridOptions !== null"
            class="ag-theme-balham flex-fill h-100 w-100"
            [gridOptions]="gridOptions">
        </ag-grid-angular>
    </div>
</div>
